import cx from "classnames";
import { RiskBadge } from "@/components/RiskBadge";
import { getIconByNetwork } from "@/helpers";
import { type AmlHistoryItemData } from "@/store/models";
import { AmlStatusEnum } from "@/config";
import { getFormattedDateWithTime } from "@/helpers";
import { BlacklistBadge } from "./components";

import styles from "./CheckEntry.module.sass";

interface CheckEntryProps {
  item: AmlHistoryItemData;
  className?: string;
  onDetails: (item: AmlHistoryItemData) => void;
}

const CheckEntry = ({ item, className, onDetails }: CheckEntryProps) => {
  const icon = getIconByNetwork(item.network);

  const classes = cx(styles.item, className);

  const isPending = item.status === AmlStatusEnum.PENDING;
  const lastChecked = getFormattedDateWithTime(item.updated_at);
  const riskScoreLevel = item.riskScoreLevel || null;
  const hasRiskScore = item.riskscore !== null;
  const blacklistFlag = item.hasBlackListFlag;

  return (
    <div className={classes}>
      <div className={styles.info}>
        <img
          src={icon}
          alt={item.network}
          loading="lazy"
          className={styles.icon}
        />
        <div className={styles.content}>
          <div className={styles.address}>{item.address}</div>
          <div className={styles.blockchain}>{item.network}</div>
        </div>
      </div>

      {isPending && (
        <div className={styles.level}>
          <p>Pending...</p>
        </div>
      )}
      {!isPending && (
        <>
          {riskScoreLevel && !blacklistFlag && (
            <div className={styles.level}>
                <RiskBadge
                  level={riskScoreLevel}
                  note={lastChecked}
                />

            </div>
          )}
          {!hasRiskScore &&
            !blacklistFlag &&
            !riskScoreLevel && (
              <div className={styles.level}>
                No risk score
              </div>
            )}
          {blacklistFlag && (
            <div className={styles.level}>
                <BlacklistBadge flag={blacklistFlag} />
              </div>
            )}

          <button
            type="button"
            className={styles.details}
            onClick={() => onDetails(item)}
          >
            Details
          </button>
        </>
      )}
    </div>
  );
};

export default CheckEntry;
